export default "__VITE_ASSET__afc06f76__"